module.exports = __webpack_public_path__ + "fr_CH-header-ff8d28.webp";